import { AxiosInstance } from "axios";
import { IObjectCreationInfo } from "../interfaces/mfiles/IObjectCreationInfo";
import { createObjectOfTypeUrl } from "../helpers/urlHelper";
import { IMfilesObject } from "../interfaces/mfiles/IMFilesObject";

// Create an item in m-files. Return object id of created object
export const addObjectAsync = async (httpClient: AxiosInstance, objectType: number, creationInfo: IObjectCreationInfo): Promise<IMfilesObject> => {
  const url = createObjectOfTypeUrl(objectType);
  const response = await httpClient.post(url, creationInfo);
  return response?.data;
};

export const addManyObjectsAsync = async (
  httpClient: AxiosInstance,
  objectType: number,
  creationInfos: IObjectCreationInfo[]
): Promise<IMfilesObject[]> => {
  return Promise.all(creationInfos.map((creationInfo) => addObjectAsync(httpClient, objectType, creationInfo)));
};
